<template>
	<div class="wrap">
		<div class="insidebanner">
			<img src="../assets/course/banner.jpg" alt="">
			<span class="insidebanner-bor"></span>
		</div>
		<div class="content">
			<div class="intro">
				<p>KA特色课程系列产品，将Etonkids独有的3C价值教育理念与家庭教育相结合，形成独特的体验式课程，加强儿童在特定领域的发展。</p>
				<p>特色课程系列产品从学术构建的完整性出发，为园所带来优质的口碑；从园所自身发展独特性出发，可以带来一定的经济效益；</p>
				<p>从Etonkids KA的3C教育理念出发，为幼儿带来丰富、广阔的探索空间，<br>从而为园所树立正确的办园思路，完善园所经营模式，搭建有品质、有特色、国际化的高端幼儿园管理体系</p>
			</div>
			<div class="course">
				<div class="course-cont course-food">
					<dl class="course-cont-dl">
						<dt><img src="../assets/course/food.png" alt=""></dt>
						<dd>
							<h4>国际双语美食课程</h4>
							<p>双语美食课程包含48个课时内容，集中在教案中（中英各一本） <br>根据园所教师和儿童的实际情况选择性授课</p>
							<p>基于幼儿美食教育理念，通过厨艺创作让幼儿感受不同国家饮食文化，将幼儿语言、文化与礼仪完美结合</p>
						</dd>
					</dl>
					<div class="course-cont-span">
						<span>①、结合食育教育理念，KA儿童之家国际小厨神美食课程旨在让儿童学习基础的厨艺技能，建立自信心和养成健康饮食的习惯</span>
						<span>②、双语食育主题学习，寓教于乐，耳濡目染</span>
						<span>③、培养儿童的健康能力、日常生活能力和独立处事能力。体验劳动的光荣，养成良好的餐桌礼仪和健康的饮食习<i class="sp-font">惯</i></span>
					</div>
				</div>
				<div class="course-cont course-esthetics">
					<dl class="course-cont-dl">
						<dt><img src="../assets/course/meixue.png" alt=""></dt>
						<dd>
							<h4>创享美学课程</h4>
							<p>八大体系培养幼儿审美素养 <br>线条涂抹、形状线索、色彩艺术、幼儿绘画、 <br>创意美术、我的世界、自然工坊、节日文化</p>
							<p>创意国际化美学课程，培养幼儿审美素养。 <br>打造幼儿园高端美学启蒙课程</p>
						</dd>
					</dl>
					<div class="course-cont-span">
						<span>①、培养幼儿审美素养，以及对美的理解力、感受力</span>
						<span>②、发展幼儿的观察能力、记忆力、想象能力、创造力及实际操作能力</span>
						<span>③、激发幼儿发现美、创造美的能力</span>
						<span>④、增强幼儿手脑协调性、促进感统协调发展</span>
					</div>
				</div>
				<div class="course-cont course-food">
					<dl class="course-cont-dl">
						<dt><img src="../assets/course/tineng.png" alt=""></dt>
						<dd>
							<h4>体适能课程</h4>
							<p>体适能课程覆盖3-6岁年龄段，每学年包含32课时每学年课程包括50个融入健康理念的瑜伽动作教学、20个音乐韵律活动、60个室内活动延伸活动</p>
							<p>用儿童瑜伽、趣味游戏、音乐律动活动形式强化体能锻炼，培养儿童对体育的热情，造就阳光而坚毅的个体</p>
						</dd>
					</dl>
					<div class="course-cont-span">
						<span>①、强化儿童体能锻炼，结合健康知识，通过各种类型的活动锻炼儿童的大肌肉、小肌肉</span>
						<span>②、在中英文双语环境中，采用多种活动形式，开展特色教学，为儿童创造学习和锻炼的环境</span>
					</div>
				</div>
			</div>
			<div class="special">
				<h4>尊享特色课程</h4>
				<img src="../assets/course/special_programs.png" alt="">
				<p>咨询电话/ Contact </p>
				<span></span>
			</div>
			<div class="apply">
				<h4>申请获取电子版课程材料包</h4>
				<Apply />
			</div>
		</div>
	</div>
</template>
<script>
	import ApplyForm from '@/components/Common/ApplyForm'
	export default {
		name: 'Course',
		data () {
			return {}
		},
		components: {
			'Apply': ApplyForm
		}
	}
</script>
<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.content {
		padding-top: 18px;
	}
	.intro {
		width: 100%;
		// height: 221px;
		background: #f2f2f4;
		text-align: center;
		padding: 58px 0 35px;
		p {
			line-height: 32px;
			font-size: 16px;
			color: #091338;
		}
	}
	.course {
		width: 100%;
		background: url(../assets/course/course_bg.jpg) center top no-repeat;
		margin-bottom: 80px;
		color: #091338;
		&-cont {
			@extend %width;
			padding-top: 74px;
			&-dl {
				@extend %clearfix;
				// height: 236px;
				dt {
					width: 526px;
					height: 236px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 8px;
					}
				}
			}
			&-span {
				span {
					display: block;
					line-height: 24px;
					font-size: 14px;
				}
			}
			h4 {
				padding-top: 6px;
				margin-bottom: 30px - 6px;
				font-weight: normal;
				font-size: 28px;
			}
			p,.sp-font {
				font-size: 18px;
			}
			p {
				height: 118px;
				line-height: 25px;
			}
			.sp-font {
				font-style: normal;
			}
		}
		&-food {
			dt {
				float: right;
			}
			dd {
				margin-right: 526px + 46px;
			}
		}
		&-esthetics {
			dt {
				float: left;
			}
			dd {
				margin-left: 526px + 46px;
				text-align: right;
			}
			.course-cont-span {
				text-align: right;
			}
		}
		
		
		
		
	}
	.special {
		height: 319px - 32px;
		background: url(../assets/course/tese_course.jpg) center top no-repeat;
		border-bottom: 6px solid #1a58a2;
		padding-top: 32px;
		text-align: center;
		color: #fff;
		h4 {
			display: inline-block;
			font-weight: normal;
			font-size: 36px;
			border-bottom: 7px solid #1a58a2;
			padding-bottom: 8px;
			margin-bottom: 12px;
		}
		img {
			display: block;
			margin: 0 auto 40px;
		}
		p {
			margin-bottom: 20px;
			font-size: 30px;
		}
		span {
			font-size: 60px;
		}
	}
	.apply {
		padding-top: 60px;
		background: url(../assets/partner/bg.jpg) repeat-y center top;
		h4 {
			margin-bottom: 30px;
			text-align: center;
			font-weight: normal;
			font-size: 30px;
			color: #1a58a2;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Course.vue